<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     模型名称
  +---------------------------------------------------------------------------------------
-->
<template>
  <span v-if="type == 'text'">{{ title }}</span>
  <el-button v-else-if="type == 'button'" type="text" @click.stop="toDetail">查看</el-button>
  <el-link v-else :underline="false" @click.stop="toDetail">{{ title }}</el-link>
</template>

<script>
import { getAccessToken } from '@/utils/cookie'
export default {
  name: "FDevName",

  props: {
    dev: {
      type: Object,
      default() {
        return {}
      },
    },

    type: {
      type: String,
      default: 'link',  // link\button\text
    },

  },

  data() {
    return {
    }
  },

  computed: {
    title() {
      return this.dev.dev_name || this.name
    }
  },

  methods: {
    toDetail() {
      const source = encodeURIComponent(window.location.href)
      const accessToken = encodeURIComponent(getAccessToken())
      const deviceid = localStorage.getItem('__DEVICEID__')
      var url = `${process.env.VUE_APP_DIM_HOST}/#/dev/detail?devid=${this.dev.devid}&access_token=${accessToken}&source=${source}&deviceid=${deviceid}`
      window.open(url, '_blank')
    }
  }
}
</script>
